import { inject, Injectable } from '@angular/core';
import { collection, collectionData, Firestore, getDocs, query, updateDoc, where } from '@angular/fire/firestore';
import { NOTIFICATION_COLLECTION } from '@damofire/data-commons';
import { Observable } from 'rxjs';
import { UserNotification } from './system-notification.dto';
import { AuthDtoSignerService } from '@damofire/data-security';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { EmitterService } from '../emitter.service';
import { MainLayoutComponent, MOBILE_UPDATE_NOTIFICATION } from '../main-layout/main-layout.component';

@Injectable({ providedIn: 'root' })
export class SystemNotificationService {
  private readonly firestore = inject(Firestore);
  private readonly dtoService = inject(AuthDtoSignerService);
  private readonly emiiterService = inject(EmitterService);

  getNotifications(userId: string): Observable<UserNotification[]> {
    return collectionData(query(collection(this.firestore, NOTIFICATION_COLLECTION), where('user._id', '==', userId)), { idField: '_id' }) as Observable<UserNotification[]>;
  }

  async checkForAppUpdates(): Promise<void> {
    const updateInfo = await AppUpdate.getAppUpdateInfo();
    if (updateInfo.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
      this.emiiterService.get(MainLayoutComponent.channelName()).next({ event: MOBILE_UPDATE_NOTIFICATION, value: true });
    }
  }

  async deleteNotification(userNotification: UserNotification): Promise<void> {
    const docPath = `${NOTIFICATION_COLLECTION}/${userNotification._id}`;
    await this.dtoService.update({ remove: true }, docPath);
  }

  async markAllNotificationsAsRead(userId: string): Promise<void> {
    const notificationRefs = query(collection(this.firestore, NOTIFICATION_COLLECTION), where('user._id', '==', userId));
    const queryDocs = await getDocs(notificationRefs);
    const today = new Date();
    const thirtyDaysAhead = today.setDate(today.getDate() + 30);

    for (const notificationDoc of queryDocs.docs) {
      if (!notificationDoc.get('read')) {
        await updateDoc(notificationDoc.ref, { read: true, expireAt: new Date(thirtyDaysAhead) });
      }
    }
  }
}
